import React from "react";

//import stock
import stock from "../img/image1.jpg";
import stock1 from "../img/image2.jpg";
import stock2 from "../img/image3.jpg";
import stock3 from "../img/image4.jpg";
import stock4 from "../img/image5.jpg";
import stock5 from "../img/image6.jpg";

class Portfolio extends React.Component {
  render() {
    return (
      <section id="work" className="portfolio-mf sect-pt4 route">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="title-box text-center">
                <h3 className="title-a">Portfolio</h3>
                <p className="subtitle-a">
                  Here are some of the projects I've worked on.
                </p>
                <div className="line-mf"></div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="work-box">
                <a href={"https://res.cloudinary.com/boresism/image/upload/v1612989123/portfolio/homepage_ym2oy8.png"} data-lightbox="gallery-vmarine">
                  <div className="work-img">
                    <img src={"https://res.cloudinary.com/boresism/image/upload/v1612989123/portfolio/homepage_ym2oy8.png"} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Recipes</h2>
                        <div className="w-more">
                          <span className="w-ctegory">
                            MongoDB ReactJS Strapi UIKit
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={"https://res.cloudinary.com/boresism/image/upload/v1612996221/portfolio/Recipe_hero_xjjvpu.png"}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={"https://res.cloudinary.com/boresism/image/upload/v1612996313/portfolio/recipe_card_bvkxf7.png"}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={"https://res.cloudinary.com/boresism/image/upload/v1612996440/portfolio/entree_yvn3vv.png"}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={"https://res.cloudinary.com/boresism/image/upload/v1613319371/portfolio/secure_index_console_f1uuet.png"} data-lightbox="gallery-aguadeluz">
                  <div className="work-img">
                    <img src={"https://res.cloudinary.com/boresism/image/upload/v1613319371/portfolio/secure_index_console_f1uuet.png"} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Symmetric Searchable Encryption Scheme</h2>
                        <div className="w-more">
                          <span className="w-ctegory">
                            Python PyQt5 Cryptography
                          </span>{" "}
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={"https://res.cloudinary.com/boresism/image/upload/v1613319372/portfolio/encrypted_documents_rn2nio.png"}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={"https://res.cloudinary.com/boresism/image/upload/v1613319372/portfolio/decrypted_documents_ar06ag.png"}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={"https://res.cloudinary.com/boresism/image/upload/v1614265517/portfolio/Game_Screen_hc5cye.png"} data-lightbox="gallery-todo">
                  <div className="work-img">
                    <img src={"https://res.cloudinary.com/boresism/image/upload/v1614265517/portfolio/Game_Screen_hc5cye.png"} alt="picture of the game pong" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Totally NOT Pong</h2>
                        <div className="w-more">
                          <span className="w-ctegory">
                            JavaScript Phaser
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={"https://res.cloudinary.com/boresism/image/upload/v1614265517/portfolio/Title_screen_tqqzeq.png"}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={stock2}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={stock3}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={stock4}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={stock5}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>


          </div>
        </div>
      </section>
    );
  }
}

export default Portfolio;
